module.exports = __webpack_public_path__ + "img/guide-mobile.0d2d4f6c.gif";